/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveBoxOpenDocsIcon20Light = forwardRef('ArchiveBoxOpenDocsIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7 1a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H7Z" }),
        React.createElement("path", { d: "M7.5 10a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4.5A1.5 1.5 0 0 1 6.5 3h7A1.5 1.5 0 0 1 15 4.5V7h1.5a.5.5 0 0 1 .5.5v8.25A2.25 2.25 0 0 1 14.75 18h-9.5A2.25 2.25 0 0 1 3 15.75V7.5a.5.5 0 0 1 .5-.5H5V4.5Zm9 0V7H6V4.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5ZM4 15.75V8h12v7.75c0 .69-.56 1.25-1.25 1.25h-9.5C4.56 17 4 16.44 4 15.75Z" })));
});
